import {ActionBuilder} from "@cuatroochenta/co-redux-builders";

export default ActionBuilder.build({
	dispatchClearReducer: () => ({}),
	dispatchAddCollectionProcessToSendList: (id: string) => (id),
	dispatchRemoveCollectionProcessToSendList: (id: string) => (id),
})
